/**
 * Compares two semver-like version strings (e.g. "0.17", "1.2.3").
 * Returns -1 if a < b, 0 if a == b, 1 if a > b.
 */
const compareVersions = (a, b) => {
    const partsA = String(a).split('.').map(Number);
    const partsB = String(b).split('.').map(Number);
    const len = Math.max(partsA.length, partsB.length);

    for (let i = 0; i < len; i++) {
        const segA = partsA[i] || 0;
        const segB = partsB[i] || 0;
        if (segA < segB) return -1;
        if (segA > segB) return 1;
    }

    return 0;
};

export default compareVersions;
